import { sendAnalytics } from '@audio-network/analytics'
import {
	Popover,
	PopoverMenu,
	PopoverMenuItem,
} from '@audio-network/componentlibrary'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

import { HelpProps } from './Help.types'

const Help = ({ className, id }: HelpProps): JSX.Element => {
	const { t } = useTranslation(['navigation'])

	const { locale } = useRouter()

	const showBlog = locale.includes('en') || locale.includes('de')
	const showChinaFAQ = locale.includes('zh')

	const handleClick = (noun: string): void => {
		sendAnalytics({
			noun,
			pastTenseVerb: 'Clicked',
			eventParameters: {
				Location: 'Music App Navigation',
			},
		})
	}

	return (
		<Popover className={className} id={id} mobileCloseLabel={t('close')}>
			<PopoverMenu>
				<PopoverMenuItem
					href={showChinaFAQ ? '/content/帮助/常见问题' : '/faq'}
					onClick={() => handleClick('FAQ')}
					content={t('faq')}
					target="_blank"
				/>
				{showBlog && (
					<PopoverMenuItem
						href="/blog"
						onClick={() => handleClick('Blog')}
						content={t('blog')}
						target="_blank"
					/>
				)}
				<PopoverMenuItem
					href="/privacy"
					onClick={() => handleClick('Privacy')}
					content={t('privacy-and-cookies')}
					target="_blank"
				/>
				<PopoverMenuItem
					href="/terms-and-conditions"
					onClick={() => handleClick('Terms and Conditions')}
					content={t('terms')}
					target="_blank"
				/>
			</PopoverMenu>
		</Popover>
	)
}

export default Help
